// extracted by mini-css-extract-plugin
export var autoExpand = "_2n-8";
export var container = "_2n-7";
export var containerWidth = "_2n-5";
export var disabled = "_2n-2";
export var error = "_2n-3";
export var fullWidth = "_2n-6";
export var inputWrapper = "_2n-0";
export var small = "_2n-1";
export var textarea = "_2n-4";